import { usePost, useGet, usePut, usePostKeycloak, usePutKeycloak } from "./useRequest";
import { getCurrentEmployeeAuthorisationId } from "utils/authHelper";
import config from "../constants/config";

export const handleEmployeeFirstLogin = (userId) => {
  // if (!path) {
  //   throw new Error("Path is required");
  // }
  // let res = {};
  const response = usePost("/UserManagement/HandleEmployeeFirstLogin", userId);
  return response;
};

export const loadUsers = (getCurrentCompanyId) => {
  const path = "/realms/qjumpers/qjumpers/companies/" + getCurrentCompanyId + "/users";
  const response = useGet(path, "KEYCLOAK");
  return response;
};

export const loadEmployees = (getCurrentCompanyId) => {
  const path = "/realms/qjumpers/qjumpers/companies/" + getCurrentCompanyId + "/employees";
  const response = useGet(path, "KEYCLOAK");
  return response;
};

export const resentActivationEmail = (userId) => {
  const path = "/UserManagement/" + userId + "/resendactivation";
  const response = usePost(path);
  return response;
};

export const addUser = (user, getCurrentCompanyId) => {
  user.companyId = getCurrentCompanyId;
  user.username = user.email;
  const redirectUrl = config.scheme + "://" + config.host;
  const path = `/realms/qjumpers/qjumpers/employees?redirectUri=${redirectUrl}&password=false`;
  const response = usePostKeycloak(path, user);
  return response;
};

export const validateToken = (token) => {
  const path = "/validate/token";
  
  const response = usePost(path, { token: `${token}` });
  return response;
};

export const saveUser = (user, getCurrentCompanyId) => {
  user.username = user.email;
  const path = "/organisations/" + getCurrentCompanyId + "/employee/";
  const response = usePut(path, user);
  return response;
};

export const uploadCSV = (csvFile) => {
  const path = `/UserManagement/UsersCsv`;
  if (!path) {
    throw new Error("Path is required");
  }
  const response = usePost(path, csvFile);
  return response;
};

export const saveProfile = (user) => {
  const path = "/realms/qjumpers/qjumpers/employees/" + user.employeeId + "/profile";
  if (!path) {
    throw new Error("Path is required");
  }
  const response = usePutKeycloak(path, user);
  return response;
};

export const getCurrentUser = (authorizationId = null) => {
  const path = `/realms/qjumpers/qjumpers/employees/${authorizationId ? authorizationId : getCurrentEmployeeAuthorisationId()}`;
  if (!path) {
    throw new Error("Path is required");
  }
  const response = useGet(path, "KEYCLOAK");
  return response;
};

export const loadEmployeesToShareSearch = (organisationId, isgsm) => {
  const path = "/organisations/" + organisationId + "/gsm/users?isGsmOrganisation=" + isgsm;
  if (!path) {
    throw new Error("Path is required");
  }
  const response = useGet(path);
  return response;
};

export function shareSearchWithUsers(orgId, searchData) {
  const path = `/organisations/${orgId}/gsm/shareglobalsearch`;
  if (!path) {
    throw new Error("Path is required");
  }
  const response = usePost(path, searchData);
  return response;
}
